import React, {Component} from 'react';
import { BrowserRouter, Route , Routes} from 'react-router-dom';
import ThemeButton from './Element/ThemeButton/ThemeButton';
import ScrollToTop from './Element/ScrollToTop';

import Index1 from './Pages/Index1';
import AboutUs2 from './Pages/AboutUs2';
import Classes from './Pages/Classes';
import Teachers from './Pages/Teachers';
import TeachersDetail from './Pages/TeachersDetail';
import ErrorPage from './Pages/ErrorPage';
import Gallery from './Pages/Gallery';
import GalleryMasonary from './Pages/GalleryMasonary';
import GalleryFilter from './Pages/GalleryFilter';
import Contact from './Pages/Contact';
import UserPage from './Pages/UserPage';

class Markup extends Component{
	render(){
		return(
			<BrowserRouter basename='/'>
				 <div className="page-wraper">		
				 	<Routes>
						<Route path='/' exact element={<Index1 />} />
						<Route path='/about-2' exact element={<AboutUs2 />} /> 		
						<Route path='/classes' exact element={<Classes/>} /> 		
						<Route path='/teachers' exact element={<Teachers/>} /> 		
						<Route path='/teachers-details' exact element={<TeachersDetail/>} /> 		
						<Route path='/error-404' exact element={<ErrorPage />} /> 		
						<Route path='/gallery' exact element={<Gallery/>} /> 		
						<Route path='/gallery-masonary' exact element={<GalleryMasonary />} /> 		
						<Route path='/gallery-filter' exact element={<GalleryFilter/>} /> 		
						<Route path='/contact-us' exact element={<Contact/>} /> 					
						<Route path='/user/:userId' exact element={<UserPage/>} /> 					
					</Routes>
				</div>	
				<ThemeButton />
				<ScrollToTop />
			</BrowserRouter>
		)
	}
}

export default Markup;
